// Simple error reporting without direct Sentry dependency
// Errors will be caught by error boundaries which handle Sentry reporting
import type { ErrorInfo } from 'react';
import { reduxLogger } from '@/core/utils/logger';
import { config } from '@/config';
export interface ErrorMetadata {
  context?: string;
  userId?: string;
  action?: string;
  extra?: Record<string, unknown>;
}

export const reportError = (
  error: Error | unknown,
  metadata?: ErrorMetadata
): void => {
  reduxLogger.error('Error reported:', error, metadata);
  
  // In production, throw the error to be caught by error boundary
  if (config.features.errorReporting && error instanceof Error) {
    throw error;
  }
};

export const reportReactError = (
  error: Error,
  errorInfo: ErrorInfo,
  metadata?: ErrorMetadata
): void => {
  reduxLogger.error('React error:', error, {
    ...metadata,
    componentStack: errorInfo.componentStack,
    digest: (errorInfo as unknown as { digest?: string }).digest,
  });
};

export const reportApiError = (
  endpoint: string,
  status: number,
  error: unknown,
  metadata?: ErrorMetadata
): void => {
  const apiError = new Error(`API Error: ${endpoint} returned ${status}`);
  reduxLogger.error('API error:', apiError, {
    ...metadata,
    endpoint,
    status,
    response: error,
  });
};

export const reportWebSocketError = (
  event: string,
  error: unknown,
  metadata?: ErrorMetadata
): void => {
  const wsError = new Error(`WebSocket Error: ${event}`);
  reduxLogger.error('WebSocket error:', wsError, {
    ...metadata,
    event,
    error,
  });
};